const Platform = {
  OS: "web",
  select: (obj) => "web" in obj ? obj.web : obj.default,
  isTesting: process.env.NODE_ENV === "test"
};
var Platform_default = Platform;
export {
  Platform_default as default
};
//# sourceMappingURL=index.js.map
